<template>
<teleport to="body">
<dialog ref="dialog" class="site-popup bg-gray-500 rounded-md p-4 z-50 items-center justify-center overflow-visible fixed mx-4 ht:mx-auto" :class="'tick-'+tick">

    <button @click="closeIt" ref="closer" class="closer absolute right-4 top-4 transition-all z-20 text-white rounded-full w-12 h-12 flex items-center justify-center bg-primary-400" aria-label="Close this dialog">
        <i class="fas fa-times text-2xl" aria-hidden="true"></i>
    </button>

    <div class="grid gap-4">
        <div class="col-span-2">
            <h1 class="font-headline text-4xl vt:text-center font-bold text-primary-800 leading-none pl-0 vt:pl-10 vt:pr-10" v-html="popup.headline"></h1>
        </div>

        <div class="col-span-2 vt:col-span-1 relative rounded-md overflow-hidden shadow-2xl photo transition-all">
            <BackgroundImage :src="popup.photo.src" :alt="popup.photo.alt"></BackgroundImage>
        </div>

        <div class="col-span-2 vt:col-span-1 flex flex-col justify-center">
            <div class="font-headline text-gray-800" v-html="popup.blurb"></div>
            <div class="flex mt-4">
                <Button :url="popup.button.href" :label="popup.button.label"></Button>
            </div>
        </div>

    </div>


</dialog>
</teleport>
</template>

<script>
import { onMounted, ref, nextTick, computed } from 'vue';
const $ = window.jQuery;
export default {

    props: ['popup'],

    emits: ['close'],

    setup(props, {emit}) {

        const dialog = ref(null);
        const tick = ref(0);
        const closer = ref(null);

        const sawIt = computed(() => {
            return window.localStorage.getItem('last_popup') == props.popup.cookie;
        });

        async function openIt() {
            tick.value = 0;
            await nextTick();
            dialog.value.showModal();
            tick.value = 1;
            await window.wait(125);
            tick.value = 2;
            await window.wait(125);
            tick.value = 3;
            $('body').addClass('overflow-y-hidden');
            $(closer.value).blur();
        };

        async function closeIt() {
            tick.value = 0;
            await window.wait(250);
            dialog.value.close();
            emit('close');
            $('body').removeClass('overflow-y-hidden');
            window.localStorage.setItem('last_popup', props.popup.cookie);
        };

        onMounted(() => {
            if (sawIt.value) {
                return;
            }
            window.wait(1000).then(openIt);
        });

        return {
            closer,
            closeIt,
            tick,
            dialog
        };

    }
}
</script>